import { render } from "./Work.vue?vue&type=template&id=f516d8c8&scoped=true"
import script from "./Work.vue?vue&type=script&lang=js"
export * from "./Work.vue?vue&type=script&lang=js"

import "./Work.vue?vue&type=style&index=0&id=f516d8c8&scoped=true&lang=css"

import exportComponent from "C:\\bluespeed\\bluespeed\\frontend\\bluespeed\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f516d8c8"]])

export default __exports__